export interface SharedSessionTarget {
  workspaceId: number | undefined;
  promptId?: number;
  workflowId?: number;
  skillCollectionId?: string;
}

export interface SharedSessionMutationTarget {
  workspace_id: number;
  prompt_id?: number;
  workflow_id?: number;
  skill_collection_id?: string;
}

export const hasSharedSessionTarget = ({
  promptId,
  workflowId,
  skillCollectionId,
}: Omit<SharedSessionTarget, "workspaceId">) =>
  promptId !== undefined ||
  workflowId !== undefined ||
  (skillCollectionId !== undefined && skillCollectionId.length > 0);

export const buildSharedSessionsQueryKey = ({
  workspaceId,
  promptId,
  workflowId,
  skillCollectionId,
}: SharedSessionTarget) =>
  [
    "shared_sessions",
    workspaceId ?? null,
    promptId ?? null,
    workflowId ?? null,
    skillCollectionId ?? null,
  ] as const;

export const buildSharedSessionExistsQueryKey = ({
  workspaceId,
  promptId,
  workflowId,
  skillCollectionId,
}: SharedSessionTarget) =>
  [
    "shared_sessions",
    "exists",
    workspaceId ?? null,
    promptId ?? null,
    workflowId ?? null,
    skillCollectionId ?? null,
  ] as const;

export const buildSharedSessionQueryParams = ({
  promptId,
  workflowId,
  skillCollectionId,
}: Omit<SharedSessionTarget, "workspaceId">) => {
  const params = new URLSearchParams();
  if (promptId !== undefined) {
    params.set("prompt_id", String(promptId));
  }
  if (workflowId !== undefined) {
    params.set("workflow_id", String(workflowId));
  }
  if (skillCollectionId !== undefined) {
    params.set("skill_collection_id", skillCollectionId);
  }
  return params;
};

export const targetFromMutationRequest = ({
  workspace_id,
  prompt_id,
  workflow_id,
  skill_collection_id,
}: SharedSessionMutationTarget): SharedSessionTarget => ({
  workspaceId: workspace_id,
  promptId: prompt_id,
  workflowId: workflow_id,
  skillCollectionId: skill_collection_id,
});
